// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"eef317411a6d85f8755c","522":"d5a9de96c93b20004382"}[chunkId] + ".js";
};